import AggregatorDashboardPage from '@/pages/dashboard/aggregator-dashboard-page';
import CommunityDashboardPage from '@/pages/dashboard/CommunityDashboardPage';
import { AuthGuard } from '@/components/auth/AuthGuard';
import { useCommunityContext } from '@/providers/community-context';
import { isAggregatorKind } from '@/lib/community-ui-mode';

/** Shared `/:communityId/dashboard` — picks page by community kind. */
export default function CommunityDashboardRouter() {
  const { community } = useCommunityContext();

  if (isAggregatorKind(community.kind)) {
    return <AggregatorDashboardPage />;
  }

  return (
    <AuthGuard>
      <CommunityDashboardPage />
    </AuthGuard>
  );
}
